import Masonry from 'masonry-layout'
import InfiniteScroll from 'infinite-scroll'
import imagesLoaded  from 'imagesloaded'

const albumsMosaic = document.querySelectorAll('.album.pinterest');
console.log('mosaic');

for (let i = 0; i < albumsMosaic.length; i++) {
    let itemClass = `item-${i}`;
    albumsMosaic[i].classList.add(itemClass);
    let grid = albumsMosaic[i].querySelector('.grid');

    let config = {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        gutter: 10,
        percentPosition: true
    }

    let masonry = new Masonry(`.album.${itemClass} .grid`, config);

    imagesLoaded( grid, function() {
        masonry.options.itemSelector = '.grid-item';
        let items = grid.querySelectorAll('.grid-item');
        masonry.reloadItems( items );
        masonry.layout();
    });


    let infiniteScroll = new InfiniteScroll( grid, {
        path: 'page{{#}}.html',
        append: '.grid-item',
        historyTitle: true,
        prefill: true,
        scrollThreshold: 1000,
        status: '.page-load-status',
        outlayer: masonry,
        debug: true
    });

}